import { ls } from "../../../core/common/ls";
/**
 * 文件下载中间件
 * @param ctx
 * @param next
 * @returns
 */
export const downloadMiddleware = async (ctx, next) => {
  const {
    cgiInfo,
    requestConfig,
    collectionId,
    cgiName,
    projectId
  } = ctx;
  const isBlob = cgiInfo.responseType === 'blob';
  if (isBlob) {
    requestConfig.responseType = 'blob';
  }
  await next();
  if (isBlob) {
    console.log(`数据源请求[${collectionId}/${cgiName}] responseType=blob,进行文件下载`);
    if (ctx.response) {
      const {
        data
      } = ctx.response;
      // 以防万一 留个后门 localStorage.setItem('__wuji_source_ls_disableCheckJsonDownload_${projectId}',1)
      const disableCheckJsonDownload = ls.get(`disableCheckJsonDownload_${projectId}`);
      // 通过 数据源插件 action=stop 会返回一个json的blob
      if (data instanceof Blob && data.type === 'application/json' && !disableCheckJsonDownload) {
        const json = await blobToJson(data);
        ctx.response.data = json;
        return;
      }
      downloadFromAxiosResponse(ctx.response, cgiName);
    }
  }
};
async function blobToJson(blob) {
  const reader = new FileReader();
  return new Promise((resolve, reject) => {
    reader.onload = function (event) {
      var _event$target;
      const jsonObj = JSON.parse((event === null || event === void 0 || (_event$target = event.target) === null || _event$target === void 0 || (_event$target = _event$target.result) === null || _event$target === void 0 ? void 0 : _event$target.toString()) || '');
      resolve(jsonObj);
    };
    reader.onerror = function (event) {
      console.error('json读取错误', event);
      reject(new Error('json读取错误'));
    };
    reader.readAsText(blob, 'UTF-8');
  });
}
function getFileNameFromContentDisposition(contentDisposition = '') {
  if (typeof contentDisposition !== 'string') {
    return null;
  }
  const match = contentDisposition.match(/\w+;\s*filename="?([^";]+)"?/);
  if (match) {
    return match[1];
  }
  return null;
}
function downloadFromAxiosResponse(response, fileName = 'default') {
  const {
    data,
    headers
  } = response;
  const blob = new Blob([data], {
    type: headers['content-type']
  });
  const dom = document.createElement('a');
  const url = window.URL.createObjectURL(blob);
  dom.href = url;
  dom.download = decodeURI(getFileNameFromContentDisposition(headers['content-disposition']) || fileName);
  dom.style.display = 'none';
  document.body.appendChild(dom);
  dom.click();
  document.body.removeChild(dom);
  window.URL.revokeObjectURL(url);
}
//# sourceMappingURL=download.js.map
